import React, { useEffect, useState } from "react";
import "react-chat-elements/dist/main.css";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import ChatComponent from "../../../../../common/chat-component/ChatComponent";
import { getChatConversationByIdAction } from "../../../../../../redux/services/chat-conversation/chatConversationServices";
import { Button, Flex } from "antd";
import { routes } from "../../../../../../constants";
import { baseRouteMakerForSuperAdmin } from "../../../../../../constants/routeConsts";

const ChatConversationChat = () => {
  /* i18n dependencies */
  const { t } = useTranslation();
  /* i18n dependencies */

  /* dispatch an action */
  const dispatch = useDispatch();
  /* dispatch an action */

  /*loading dependencies */
  const [, setLoading] = useState(false);
  /*loading dependencies */

  const { selectedChatConversationId } = useSelector(
    (state) => state.chatConversations
  );
  const [chatConversationMessages, setChatConversationMessages] = useState([]);
  const [chatTitle, setChatTitle] = useState({});

  useEffect(() => {
    if (
      selectedChatConversationId &&
      selectedChatConversationId !== null &&
      selectedChatConversationId !== "" &&
      selectedChatConversationId !== undefined
    ) {
      const dataToBeSent = {
        selectedChatConversationId,
      };
      dispatch(getChatConversationByIdAction(dataToBeSent, setLoading)).then(
        (apiRes) => {
          // If you are a 3rd person viewing the chat between two people (service provider and customer) then you will need to pass customer_id for comparison
          const messages = apiRes?.messages?.map((element)=>{
            return {
              ...element,
              customer_id:apiRes?.to_id?._id
            }
          })
          setChatConversationMessages(messages);
          setChatTitle(apiRes);
        }
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /* on submit */

  // If you are a 3rd person viewing the chat between two people (service provider and customer) then you will need to pass customer_id for comparison

  return (
    <Flex vertical gap="1rem">
      <ChatComponent
        chatList={[]}
        chatMessages={chatConversationMessages}
        selectedUserDetails={chatTitle}
        onChatClicked={() => {}}
        onSubmit={() => {}}
        disabledChat={true}
        isChat={true}
        isChatList={false}
        backButtonDetails={{
          isBackButton:true,
          navigate:baseRouteMakerForSuperAdmin(routes.CHAT_ACCESS_CHAT_CONVERSATION)
        }}
      />
    </Flex>
  );
};

export default ChatConversationChat;
